import { logout } from '@dtx-company/ithaca-sdk/src'

export function useLogoutMethod(): () => Promise<void> {
  return logout
}
